module.exports = __webpack_public_path__ + "media/images/placeholders/betroffene-5a790701191bf6b55d8fe16b4b27ee8f.jpg";